/**
 * VariantInfo wraps the variant selector logic providing Callouts etc. for the currently selected variant codes.
 */
export default class VariantInfo {
    constructor(variants) {
        this._variants = variants || [];
        this._onChangeHandlers = [];
        this._codePrefixes = this._variants.length > 0 ? variants[0].Codes.map(c => codePrefix(c)) : [];    

        // Array of maps - inner map lists codes, outer array index gives the position the code belongs.
        this._codePositionMap = this._variants.length > 0 ? variants[0].Codes.map(c => { return {}; }) : [];
        this._variants.forEach(v => {
            v.Codes.forEach((c, i) => {
                this._codePositionMap[i][c] = true;
            });
        });

        this._selectedCodes = new Array(this._codePositionMap.length).fill(null);

        // public API
        this.SelectedVariant = null;
        this.Callouts = {};
    }

    // set a variant code, then notify changes
    setCode(code) {
        const index = this._findCodeIndex(code);

        this._setCode(index, code);
    }

    unsetCode(code) {
        const index = this._findCodeIndex(code);

        this._setCode(index, null);
    }

    isCodeSelected(code) {
        return this._selectedCodes.indexOf(code) >= 0;
    }

    setVariantById(variantId) {
        let variant = this._variants.filter(v => parseInt(v.WebId) === parseInt(variantId));

        if (variant.length === 1) {
            variant = variant[0];

            variant.Codes.forEach(x => this.setCode(x));
            this._onCodesChange();
        }
    }

    getSelectedCodeByPrefix(prefix) {
        prefix = codePrefix(prefix);
        const index = this._codePrefixes.indexOf(prefix);

        return this._selectedCodes[index];
    }

    // subscribe to changes
    onChange(f) {
        this._onChangeHandlers.push(f);
    }

    _findCodeIndex(code) {
        return this._codePositionMap.reduce((prev, current, i) => {
            if (current[code]) {
                return i;
            } else {
                return prev;
            }
        }, -1);
    }

    _setCode(index, code) {
        this._selectedCodes[index] = code || null;
        this._onCodesChange();
    }

    _onCodesChange() {
        this._updateSelectedVariant();
        this._updateCallouts();
        this._handleChange();
    }

    _handleChange() {
        this._onChangeHandlers.forEach(f => f());
    }

    _updateSelectedVariant() {
        const setVariants = this._getVariantsForCodeSet(this._selectedCodes);
        let variant = null;

        if (setVariants.length === 1) {
            variant = setVariants[0];
        }

        this.SelectedVariant = variant;
    }

    _updateCallouts() {
        const codeSubsets = this._getCodeSubsets();
        const calloutSubsets = codeSubsets.map((cs, i) => this._getCalloutsForCodeSet(cs, i));
       
        // flatten calloutSubsets
        const callouts = this._initCallouts();

        calloutSubsets.forEach(cs => {
            cs.forEach(c => {
                if ((c.callouts == null || c.callouts.Name == "LowInventory") && callouts[c.code] != null)
                    callouts[c.code] = c.callouts;
                else if(callouts[c.code] != null && callouts[c.code].Name == "SoldOut")
                    callouts[c.code] = c.callouts;
            });
        });

        this.Callouts = callouts;
    }

    _getVariantsForCodeSet(codeSet) {
        return this._variants
            .filter(v => arrayDiff(codeSet, v.Codes).length === 0);
    }

    _getCalloutsForCodeSet(codeSet, i) {
        const setVariants = this._getVariantsForCodeSet(codeSet);

        return setVariants.map(v => { return { code: v.Codes[i], callouts: v.Callout }; });
    }

    // All Subsets of _selectedCodes excluding one code index
    // ex: ["C001", "S123"] has subsets ["C001"] and ["S123"]
    // ex: ["C001", "S123", "W456"] 1st subset == ["C001", "S123"]
    _getCodeSubsets() {
        return new Array(this._selectedCodes.length).fill()
            .map((x, i) => this._selectedCodes.filter((y, j) => i !== j));
    }

    _initCallouts() {
        const ret = {};
        this._codePositionMap.forEach(map => {
            for (let name in map) {
                if (map.hasOwnProperty(name)) {
                    ret[name] = { Name: 'SoldOut' };
                }
            }
        });
        return ret;
    }
}

function arrayDiff(a, b) {
    const ret = a.filter(x => x == null ? false : b.indexOf(x) < 0);
    return ret;
}

function codePrefix(code) {
    return code.substr(0, 1);
}


// WEBPACK FOOTER //
// ./assets/js/HSN/VariantInfo.js